import { BlockDiffChangeType, type BlockDiffData } from '@gitbook/doc-core';
import { Icon } from '@gitbook/spine-icons';
import { assertNever } from '@gitbook/util-ts';

export function BlockDiffIcon(props: { diff: BlockDiffData['type'] }) {
    switch (props.diff) {
        case BlockDiffChangeType.Modified:
        case BlockDiffChangeType.ModifiedInside:
            return <Icon.Edit aria-hidden="true" className="text-diff-modified" size={16} />;
        case BlockDiffChangeType.Added:
            return <Icon.Plus aria-hidden="true" className="text-diff-added" size={16} />;
        case BlockDiffChangeType.Deleted:
            return <Icon.Minus aria-hidden="true" className="text-diff-deleted" size={16} />;
        default:
            assertNever(props.diff);
    }
}
